module.exports = __webpack_public_path__ + "static/img_1434-9d223393eb7234ee3df914ed94c57299.webp";